<!--
 * @Descripttion:
 * @version:
 * @Author: loong
 * @Date: 2022-10-13 19:33:35
 * @LastEditors: loong
 * @LastEditTime: 2022-10-13 19:40:05
-->
<template>
  <!--<transition name="el-zoom-in-center">-->
  <transition>
    <div @click="toTop" v-show="topShow" class="me-to-top">
      <span class="iconfont ">&#xe7c4;</span>
    </div>
  </transition>
</template>

<script>
  export default {
    name: "GoTop",
    data() {
      return {
        topShow: false,
      };
    },
    methods: {
      toTop() {
        let scrolltop = document.body.scrollTop || document.documentElement.scrollTop
        console.log(scrolltop);

        document.documentElement.scrollTop = 0;

        // document.documentElement.scrollTop = 0;

        this.topShow = false;
      },
      needToTop() {
        let curHeight =
          document.documentElement.scrollTop || document.body.scrollTop;

        if (curHeight > 400) {
          this.topShow = true;
        } else {
          this.topShow = false;
        }
      },
    },
    mounted() {
      /**
       * 等到整个视图都渲染完毕
       */
      this.$nextTick(function() {
        window.addEventListener("scroll", this.needToTop);
      });
    },
  };
</script>

<style>
  .me-to-top {
    background-color: #eff3f5;
    position: fixed;
    right: 5vw;
    bottom: 150px;
    width: 40px;
    height: 40px;
    border-radius: 10px;
    cursor: pointer;
    transition: 0.3s;
    box-shadow: 0 0 6px rgba(0, 0, 0, 0.12);
    z-index: 999;
    font-weight: 700;
  }

  .me-to-top span {
    color: #007aff;
    display: block;
    line-height: 40px;
    text-align: center;
    font-size: 18px;
  }
</style>
